import {Button, Col, Row} from "reactstrap";
import classnames from "classnames";
import {CustomInput} from "../../Common/Components/Input/CustomInput";
import RequestReimbursementFixed from "../Models/Request/RequestReimbursementFixed";
import React, {useEffect, useRef, useState} from "react";
import {CustomSubmitButton} from "../../Common/Components/Input/CustomSubmitButton";
import _ from "lodash";
import {useTranslation} from "react-i18next";
import {ToCustomDecimal} from "../../AppSystem/Helpers/ToCustomDecimal";
import {ChangeDateFormat} from "../../Common/Helpers/ChangeDateFormat";
import $ from "jquery";
import { SlidePanel } from "../../Common/Components/Modal/SlidePanel";
import { CheckMobile } from '../../AppSystem/Helpers/CheckMobile';

export function ReimbursementFixed({data, dataFixed, onChange, onValidate, onCancel, editMode = false, showDate = false, isFixed = false, minFixedAmount = 0}) {
    const { t } = useTranslation();
    const isMobile = CheckMobile(998);

    const [cancelModels, setCancelModels] = useState(null);
    const [cancelModel, setCancelModel] = useState(null);
    const [activeTab, setActiveTab] = useState("1");
    const [panelOpen, setPanelOpen] = useState(false);
    const formDivRefFixed = useRef(null);
    const hiddenInputRef = useRef(null);
    const initialDataRef = useRef(null);
    const initialDataFixedRef = useRef(null);

    const captureSnapshot = () => {
        initialDataRef.current = _.cloneDeep(data);
        initialDataFixedRef.current = _.cloneDeep(dataFixed);
    };

    useEffect(() => {
        if (editMode === true && cancelModels === null && cancelModel === null) {
            const copyModels = _.cloneDeep(data);
            setCancelModels(copyModels);
            const copyModel = _.cloneDeep(dataFixed);
            setCancelModel(copyModel);
            captureSnapshot();
            if (copyModels.length > 0) {
                if (copyModels[0].type === 'Fixed' || isFixed === true) {
                    setActiveTab('2');
                } else {
                    setActiveTab('1');
                }
            }
            setPanelOpen(true);
        }
    }, [data]);

    if (editMode === true) {
        setTimeout(() => {
            data.length > 0 && data.map((item) => {
                if (item.hours === 0) {
                    $("#fixed" + item.salaryDate).find(".hourDiv").find("input").val("0");
                }
            });
        }, 80);
    }

    useEffect(() => {
        if (panelOpen) {
            if (isMobile) {
                setTimeout(() => {
                    const input = formDivRefFixed.current?.querySelector('input:not([type="hidden"])');
                    if (input) {
                        input.focus();
                        input.click();
                    }
                }, 350);
            } else {
                setTimeout(() => {
                    const input = formDivRefFixed.current?.querySelector('input');
                    input?.focus();
                }, 300);
            }
        }
    }, [panelOpen, activeTab]);

    const HandleToggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    if (data.length > 0) {
        data.sort((a, b) => new Date(a.salaryDate) - new Date(b.salaryDate));
    }

    const handleClose = () => {
        setPanelOpen(false);
        if (editMode && cancelModels !== null) {
            onCancel(cancelModels, cancelModel);
        }
    };

    const totalHours = data.reduce((sum, item) => sum + (Number(item.hours) || 0), 0);
    const isButtonDisabled = activeTab === "1"
        ? totalHours <= 0
        : !dataFixed.amount || dataFixed.amount <= 0 || dataFixed.amount < minFixedAmount;
    const hasUnsavedChanges =
        !_.isEqual(data, initialDataRef.current) ||
        !_.isEqual(dataFixed, initialDataFixedRef.current);

    return (
        <>
            {/* Invisible input to keep the keyboard active on mobile */}
            <input
                ref={hiddenInputRef}
                type="text"
                style={{
                    position: 'fixed',
                    opacity: 0,
                    pointerEvents: 'none',
                    width: 1,
                    height: 1,
                    top: 0,
                    left: 0,
                    fontSize: 16,
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                }}
                readOnly={false}
                tabIndex={-1}
                aria-hidden="true"
            />

            {/* Trigger button */}
            <button
                type="button"
                onClick={() => {
                    if (isMobile) {
                        hiddenInputRef.current?.focus();
                    }
                    captureSnapshot();
                    setPanelOpen(true);
                }}
                className="rfc-trigger-btn"
            >
                <div className="rfc-trigger-btn-left">
                    <i className="bx bx-purchase-tag fs-5" />
                    {t('reimbursement.addSalary')}
                </div>
                <i className="bx bx-chevron-right fs-5" />
            </button>

            <SlidePanel
                isOpen={panelOpen}
                onClose={handleClose}
                title={t('reimbursement.addSalary')}
                zIndexOffset={20}
                variant="center"
                closeOnOutsideClick={false}
            >
                <div ref={formDivRefFixed} className="rfc-panel-body-gap24">

                    {/* ── Pill tabs ── */}
                    <div className="rfc-pill-tabs">
                        {[
                            { id: "1", label: t('reimbursement.movable'), action: "hourly" },
                            { id: "2", label: t('reimbursement.fixed'),   action: "fixed"  },
                        ].map(tab => (
                            <button
                                key={tab.id}
                                type="button"
                                onClick={() => { HandleToggle(tab.id); onChange("", tab.action); }}
                                className={activeTab === tab.id ? "rfc-pill-tab-active" : "rfc-pill-tab-inactive"}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>

                    {/* ── Tab 1: Hourly ── */}
                    {activeTab === "1" && (
                        <div>
                            {data.length > 0 && data.map((item, index) => (
                                <div key={"fixed" + item.salaryDate} id={"fixed" + item.salaryDate} style={{ marginBottom: 16 }}>
                                    {data.length > 1 && ((item.toDate && item.toDate !== "") || showDate === true) && (
                                        <div className="rfc-hourly-date-label">
                                            {ChangeDateFormat("date", item.salaryDate)}
                                        </div>
                                    )}
                                    <div className="hourDiv position-relative rfc-hourly-row">
                                        <div className="rfc-hourly-input-wrap">
                                            {index === 0 && (
                                                <label className="rfc-hourly-label">
                                                    {t('modelLabel.hours')}
                                                </label>
                                            )}
                                            <CustomInput
                                                model={RequestReimbursementFixed}
                                                attribute='hours'
                                                data={item.hours && item.hours !== 0 ? item.hours : ""}
                                                customChange={(e) => onChange(e, "hours", index)}
                                                disableBlurValidation={true}
                                            />
                                            {index === 0 && (
                                                <div id="errorMovableAmount" className="error tooltip-custom-normal show-custom d-none rfc-error">
                                                    {t('validationMessage.totalHourMustBeMoreThan0')}
                                                </div>
                                            )}
                                        </div>
                                        <span className="rfc-hourly-equals" style={{ paddingTop: index === 0 ? 20 : 0 }}>=</span>
                                        <div id="divAmountHourly" className="rfc-hourly-amount" style={{ marginTop: index === 0 ? 20 : 0 }}>
                                            {item.amount !== 0 ? ToCustomDecimal(item.amount) : 0} kr
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {/* Submit button full-width */}
                            <div className={`rfc-btn-row ${data.length === 0 ? "d-none" : ""}`} style={{ marginTop: 8 }}>
                                {editMode === true && (
                                    <button
                                        type="button"
                                        onClick={() => { onCancel(cancelModels, cancelModel); setPanelOpen(false); }}
                                        className="rfc-btn-cancel"
                                    >
                                        {t('button.cancel')}
                                    </button>
                                )}
                                <button
                                    type="button"
                                    onClick={() => {
                                        onValidate(data);
                                        if ($("#errorMovableAmount").hasClass("d-none")) {
                                            setPanelOpen(false);
                                        }
                                    }}
                                    className="rfc-btn-primary"
                                    //disabled={isButtonDisabled}
                                    //style={isButtonDisabled ? { opacity: 0.45, cursor: 'not-allowed' } : {}}
                                >
                                    {editMode === true ? t('button.save') : t('reimbursement.addSalary')}
                                </button>
                            </div>
                        </div>
                    )}

                    {/* ── Tab 2: Fixed amount ── */}
                    {activeTab === "2" && (
                        <div>
                            <div className="position-relative" style={{ marginBottom: 24 }}>
                                <CustomInput
                                    model={RequestReimbursementFixed}
                                    attribute='amount'
                                    data={dataFixed.amount && dataFixed.amount !== 0 ? dataFixed.amount : ""}
                                    customChange={(e) => onChange(e, "amount", null, "fixed")}
                                />
                                <div id="errorFixedAmount" className="error tooltip-custom-normal show-custom d-none rfc-error" />
                            </div>

                            <div className={`rfc-btn-row ${data.length === 0 ? "d-none" : ""}`}>
                                {editMode === true && (
                                    <button
                                        type="button"
                                        onClick={() => { onCancel(cancelModels, cancelModel); setPanelOpen(false); }}
                                        className="rfc-btn-cancel"
                                    >
                                        {t('button.cancel')}
                                    </button>
                                )}
                                <button
                                    type="button"
                                    onClick={() => { 
                                        onValidate();
                                        if ($("#errorFixedAmount").hasClass("d-none")) {
                                            setPanelOpen(false);
                                        }
                                    }}
                                    className="rfc-btn-primary"
                                    //disabled={isButtonDisabled}
                                    //style={isButtonDisabled ? { opacity: 0.45, cursor: 'not-allowed' } : {}}
                                >
                                    {editMode === true ? t('button.save') : t('reimbursement.addSalary')}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </SlidePanel>
        </>
    );
}